import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, TextField, Grid, Paper, MenuItem, Tooltip, Typography, Alert, IconButton, Autocomplete, Modal, Box } from "@mui/material";
//import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from '@mui/icons-material/Close';
import DiscountIcon from '@mui/icons-material/LocalOffer'; // or use PriceCheckIcon / MonetizationOnIcon
import { Avatar } from "@mui/material";
import Swal from "sweetalert2";
import api from "../../api"; // নিশ্চিত করো src/api/index.js আছে

const StudentBill = () => {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [sessions, setSessions] = useState([]);
    const [filters, setFilters] = useState({
        session: null
    });
    const [classList, setClassList] = useState([]);
    const [sections, setSections] = useState([]);
    const [rolls, setRolls] = useState([]);
    const [selectedClass, setSelectedClass] = useState("");
    const [selectedSection, setSelectedSection] = useState("");
    const [selectedRoll, setSelectedRoll] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [student, setStudent] = useState(null);
    const [fees, setFees] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [selectedFee, setSelectedFee] = useState(null);

    const [paymentMode, setPaymentMode] = useState("");
    const [utrNumber, setUtrNumber] = useState("");
    const [filteredFees, setFilteredFees] = useState([]);
    const [discountAmount, setDiscountAmount] = useState("");
    const schoolId = localStorage.getItem("school_id");

    // small formatter
    const formatCurrency = (amount) => {
        const val = Number(amount) || 0;
        return new Intl.NumberFormat("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(val);
    };

    // initial auth check + load user
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) {
            navigate("/login");
            return;
        }
        const storedUser = {
            id: localStorage.getItem("id"),
            user_id: localStorage.getItem("user_id"),
            name: localStorage.getItem("name"),
            mobile: localStorage.getItem("mobile"),
            role: localStorage.getItem("role"),
        };
        setUser(storedUser);
    }, [navigate]);

    // ✅ Handle Payment Submission
    // const handleSubmit = () => {
    //     if (!selectedFee) {
    //         Swal.fire({ icon: "warning", title: "Oops...", text: "Please select a payment mode!" });
    //         return;
    //     }

    //     let feeType = selectedFee.id;
    //     let amount = discountAmount;

    //     const paymentData = {
    //         student_id: selectedFee.student_id,
    //         class_id: selectedFee.class_id,
    //         fee_type: feeType,
    //         amount,
    //         collected_by: user?.id,
    //     };

    //     console.log("✅ Sending Payment Data:", paymentData);

    //     fetch("https://dgps.co.in/api/student-discount", {
    //         method: "POST",
    //         headers: { "Content-Type": "application/json", "Accept": "application/json" },
    //         body: JSON.stringify(paymentData),
    //     })
    //         .then(response => response.json())
    //         .then(data => {
    //             if (data.status) {
    //                 Swal.fire({
    //                     icon: "success",
    //                     title: "Discount updated successfully",
    //                     text: `₹ ${amount} has been Discount successfully!`,
    //                     confirmButtonColor: "#3f51b5",
    //                 });

    //                 setOpenModal(false);
    //                 handleSearch();

    //             } else {
    //                 throw new Error(data.message);
    //             }
    //         })
    //         .catch(error => {
    //             Swal.fire({
    //                 icon: "error",
    //                 title: "Discount update failed",
    //                 text: error.message || "Something went wrong. Please try again.",
    //             });
    //             setOpenModal(false);
    //         });
    // };

    // উপরে নিশ্চিত করো: import api from "../api"; import Swal from "sweetalert2";
    const handleSubmit = async () => {
        // basic validations
        if (!selectedFee) {
            Swal.fire({ icon: "warning", title: "Oops...", text: "Please select a fee item!" });
            return;
        }

        if (!discountAmount || !/^\d+(\.\d{1,2})?$/.test(String(discountAmount).trim())) {
            Swal.fire({ icon: "warning", title: "Invalid amount", text: "Please enter a valid numeric discount amount." });
            return;
        }

        const feeType = selectedFee.id; // fee structure id (or fee identifier)
        const amount = parseFloat(String(discountAmount).trim());
        const student_id = selectedFee.student_id;
        const class_id = selectedFee.class_id || (student && student.class_id) || "";
        const collected_by = user?.id;
        const academic_year_id = filters.session?.id;

        if (!student_id || !collected_by) {
            Swal.fire({ icon: "error", title: "Missing data", text: "Student or current user info is missing. Please re-login." });
            return;
        }

        const school_id = localStorage.getItem("school_id") || "";

        const payload = {
            student_id,
            academic_year_id,
            class_id,
            fee_type: feeType,
            amount,
            collected_by,
            // include school_id in body as a fallback (server also reads header)
            school_id
        };

        try {
            // show a small loading indicator (optional)
            Swal.fire({
                title: "Applying discount...",
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading()
            });

            // api interceptor will attach Authorization and X-School-Id from localStorage,
            // but we also pass school_id in body for extra safety.
            const res = await api.post("/student-discount", payload);

            Swal.close();

            const data = res?.data ?? {};

            if (data.status) {
                Swal.fire({
                    icon: "success",
                    title: "Discount updated",
                    text: `₹ ${amount.toFixed(2)} applied successfully.`,
                    confirmButtonColor: "#3f51b5",
                });

                setOpenModal(false);
                setDiscountAmount("");
                // refresh the student/fees view
                if (typeof handleSearch === "function") handleSearch();
            } else {
                // server responded but status=false
                Swal.fire({
                    icon: "error",
                    title: "Failed",
                    text: data.message || "Discount update failed.",
                });
                setOpenModal(false);
            }
        } catch (err) {
            Swal.close();

            const status = err?.response?.status;
            const serverMsg = err?.response?.data?.message || err?.message || "Something went wrong";

            // If unauthorized -> redirect to login
            if (status === 401) {
                Swal.fire({
                    icon: "error",
                    title: "Session expired",
                    text: "Please login again."
                }).then(() => {
                    localStorage.clear();
                    window.location.href = "/app/login";
                });
                return;
            }

            // 422/400 etc. show server message
            Swal.fire({
                icon: "error",
                title: "Error",
                text: serverMsg
            });
            setOpenModal(false);
            console.error("Discount API error:", err);
        }
    };

    const handleOpenModal = (fee, student) => {
        setSelectedFee({ ...fee, student_id: student?.id, class_id: student?.class_id }); // ✅ student_id যোগ করা হলো
        setOpenModal(true);
    };


    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedFee(null);
    };
    const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

    // 🧩 Init
    useEffect(() => {
        fetchSessions();
    }, []);

    // 🧩 Fetch Sessions
    const fetchSessions = async () => {
        try {
            const res = await api.get("school/academic_year/list", {
                headers: { "X-School-Id": schoolId },
            });

            if (res.data?.status !== false) {
                const data = res.data.data || [];
                data.sort((a, b) => (a.status === "active" ? -1 : 1));
                setSessions(data);

                // Auto-select active session
                if (!filters.session && data.length) {
                    const active = data.find((s) => s.status === "active");
                    setFilters((p) => ({ ...p, session: active || data[0] }));
                }
            }
        } catch {
            Swal.fire("Error", "Failed to fetch sessions", "error");
        }
    };

    useEffect(() => {
        const fetchClasses = async () => {
            try {
                const res = await api.get("/get-classes");

                if (res.data && res.data.success) {
                    setClassList(res.data.data); // backend e data array ache
                } else {
                    setClassList([]);
                    console.warn("Unexpected response:", res.data);
                }
            } catch (error) {
                setClassList([]);
                console.error("Error fetching classes:", error);
            }
        };

        fetchClasses();
    }, []);

    useEffect(() => {
        const fetchSection = async () => {
            try {
                const res = await api.get(`/get-sections/${selectedClass}`);

                if (res.data && res.data.success) {
                    setSections(res.data.data); // backend e data array ache
                } else {
                    setSections([]);
                    console.warn("Unexpected response:", res.data);
                }
            } catch (error) {
                setSections([]);
                console.error("Error fetching classes:", error);
            }
        };

        fetchSection();
    }, [selectedClass]);

    useEffect(() => {
        const fetchRoll = async () => {
            try {
                const res = await api.get(`/get-rolls/${selectedSection}`);

                if (res.data && res.data.success) {
                    // ✅ remove duplicate roll_no
                    const uniqueRolls = Array.from(
                        new Map(
                            res.data.data.map((r) => [r.roll_no, r])
                        ).values()
                    );

                    setRolls(uniqueRolls);
                    setSelectedRoll("");
                } else {
                    setRolls([]);
                }
            } catch (error) {
                setRolls([]);
                console.error("Error fetching rolls:", error);
            }
        };

        if (selectedSection) fetchRoll();
    }, [selectedSection]);

    // ✅ Optimized handleSearch Function

    const handleSearch = async () => {
        const params = new URLSearchParams();
        if (filters.session) params.append("academic_year_id", filters.session.id);
        if (searchTerm) params.append("query", searchTerm);
        if (selectedClass) params.append("class_id", selectedClass);
        if (selectedSection) params.append("section_id", selectedSection);
        if (selectedRoll) params.append("roll_no", selectedRoll);

        try {
            // api interceptor তোমার localStorage থেকে token ও X-School-Id যোগ করবে
            const url = `/search-student-all?${params.toString()}`;
            const res = await api.get(url);

            // 안전하게 data অরকে
            const data = res?.data || {};

            if (data.status && Array.isArray(data.students) && data.students.length > 0) {
                const studentData = data.students[0];

                setStudent(studentData);

                // Prefer explicit fees array from backend; otherwise compose from monthly/yearly
                if (studentData.fees && Array.isArray(studentData.fees)) {
                    setFees(studentData.fees);
                } else {
                    const combined = [
                        ...(studentData.yearly_fees || []),
                        ...(studentData.monthly_fees || [])
                    ];
                    setFees(combined);
                }
            } else {
                // no student found
                setStudent(null);
                setFees([]);
                // optional user feedback
                // Swal.fire({ icon: 'info', title: 'No student found', text: data.message || 'No matching student.' });
            }
        } catch (err) {
            console.error("Error fetching student:", err);

            const status = err?.response?.status;
            if (status === 401) {
                // unauthorized: clear and redirect to login
                if (typeof Swal !== "undefined") {
                    Swal.fire({
                        icon: "error",
                        title: "Session expired",
                        text: "Please login again."
                    }).then(() => {
                        localStorage.clear();
                        window.location.href = "/login";
                    });
                } else {
                    localStorage.clear();
                    window.location.href = "/login";
                }
                return;
            }

            // other errors
            if (typeof Swal !== "undefined") {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: err?.response?.data?.message || err.message || "Failed to fetch student data."
                });
            } else {
                alert(err?.response?.data?.message || err.message || "Failed to fetch student data.");
            }

            setStudent(null);
            setFees([]);
        }
    };




    // ✅ `useEffect` to Update `filteredFees` (Optimize and Clean)
    useEffect(() => {
        setFilteredFees(fees); // ✅ Show all fees directly
        console.log("update fees", fees);
    }, [fees, student]);





    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100vh", marginTop: "0px" }}>
            <div style={{ display: "flex", flex: 1 }}>
                <div className="p-5" style={{ flex: 1, margin: "5px" }}>

                    {/* Filter Section */}
                    <Paper elevation={4} style={{
                        padding: "20px",
                        borderRadius: "12px",
                        background: "#f9f9f9",
                        marginBottom: "10px"
                    }}>
                        <Grid container spacing={2}>
                            <Grid item xs={3}>
                                <Autocomplete
                                    options={sessions}
                                    getOptionLabel={(opt) =>
                                        `${opt.session_name || ""}${opt.status ? ` (${opt.status})` : ""}`
                                    }
                                    value={filters.session}
                                    onChange={(_, v) => setFilters((p) => ({ ...p, session: v }))}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Select Session" fullWidth />
                                    )}
                                    clearOnEscape
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <Autocomplete
                                    options={classList}
                                    getOptionLabel={(option) => option.class_name}
                                    value={classList.find((cls) => cls.id === selectedClass) || null}
                                    onChange={(event, newValue) => {
                                        setSelectedClass(newValue ? newValue.id : "");
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Class"
                                            fullWidth
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {selectedClass && (
                                                            <IconButton
                                                                onClick={() => setSelectedClass("")}
                                                                edge="end"
                                                                size="small"
                                                            >
                                                            </IconButton>
                                                        )}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                            </Grid>

                            {/* Section Selection */}
                            <Grid item xs={3}>
                                <Autocomplete
                                    options={selectedClass ? sections : []}
                                    getOptionLabel={(option) => option.section_name}
                                    value={sections.find((sec) => sec.id === selectedSection) || null}
                                    onChange={(event, newValue) => {
                                        setSelectedSection(newValue ? newValue.id : "");
                                    }}
                                    disabled={!selectedClass}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Section"
                                            fullWidth
                                            disabled={!selectedClass}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {selectedSection && (
                                                            <IconButton
                                                                onClick={() => setSelectedSection("")}
                                                                edge="end"
                                                                size="small"
                                                            >
                                                            </IconButton>
                                                        )}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                            </Grid>

                            {/* Roll Number Selection */}
                            <Grid item xs={3}>
                                <Autocomplete
                                    options={selectedSection ? rolls : []}
                                    getOptionLabel={(option) => option.roll_no} // Convert to string
                                    value={rolls.find((roll) => roll.roll_no === selectedRoll) || null}
                                    onChange={(event, newValue) => {
                                        setSelectedRoll(newValue ? newValue.roll_no : "");
                                    }}
                                    disabled={!selectedSection}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Roll Number"
                                            fullWidth
                                            disabled={!selectedSection}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {selectedRoll && (
                                                            <IconButton
                                                                onClick={() => setSelectedRoll("")}
                                                                edge="end"
                                                                size="small"
                                                            >
                                                            </IconButton>
                                                        )}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid item xs={4}>
                                <TextField
                                    fullWidth
                                    label="Search (Name, Mobile, ID)"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    InputProps={{
                                        endAdornment: (
                                            <>
                                                {searchTerm && (
                                                    <IconButton
                                                        onClick={() => setSearchTerm("")}
                                                        edge="end"
                                                        size="small"
                                                    >
                                                        <ClearIcon />
                                                    </IconButton>
                                                )}
                                            </>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={4} style={{ display: "flex", justifyContent: "center" }}>
                                <Button
                                    variant="contained"
                                    onClick={handleSearch}
                                    startIcon={<SearchIcon />}
                                    style={{
                                        background: "linear-gradient(90deg, #4e54c8 0%, #8f94fb 100%)",
                                        color: "#fff",
                                        padding: "12px 30px",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                        borderRadius: "12px",
                                        textTransform: "none",
                                        boxShadow: "0 8px 16px rgba(78, 84, 200, 0.3)",
                                        transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                    }}
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.transform = "scale(1.05)";
                                        e.currentTarget.style.boxShadow = "0 12px 20px rgba(78, 84, 200, 0.5)";
                                    }}
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.transform = "scale(1)";
                                        e.currentTarget.style.boxShadow = "0 8px 16px rgba(78, 84, 200, 0.3)";
                                    }}
                                >
                                    Search Student
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>

                    {/* Student Details & Fees */}
                    <Grid container spacing={2}>
                        {/* Student Details Section */}
                        <Grid item xs={12} sm={12} md={4}>
                            <Paper elevation={4} style={{ padding: "20px", borderRadius: "12px", background: "#f9f9f9" }}>
                                <Typography variant="h6" gutterBottom style={{ fontWeight: "bold", textAlign: "center", color: "#333", borderBottom: "2px solid #3f51b5", paddingBottom: "8px", marginBottom: "10px" }}>
                                    🎓 Student Details
                                </Typography>

                                {student?.file ? (
                                    <div style={{ display: "flex", justifyContent: "center", marginBottom: "15px" }}>
                                        <img
                                            src={student.file}
                                            alt="Student"
                                            style={{
                                                width: "120px",
                                                height: "120px",
                                                borderRadius: "50%",
                                                objectFit: "cover",
                                                border: "2px solid #3f51b5",
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <div style={{ textAlign: "center", marginBottom: "15px", color: "#888" }}>
                                        <Typography variant="body2" style={{ fontStyle: "italic" }}>
                                            No Photo Available
                                        </Typography>
                                    </div>
                                )}

                                {student ? (
                                    <div style={{ display: "grid", gap: "8px" }}>
                                        {renderDetail("🆔 Student ID", student.student_code)}
                                        {renderDetail("👤 Name", student.name)}
                                        {renderDetail("🏫 Class", student.class)}
                                        {renderDetail("📚 Section", student.section)}
                                        {renderDetail("🔢 Roll No", student.roll_numbers)}
                                        {renderDetail("📞 Mobile", student.mobile)}
                                    </div>
                                ) : (
                                    <Typography variant="body1" style={{ textAlign: "center", color: "#777", fontStyle: "italic", paddingTop: "10px" }}>
                                        No Student Selected
                                    </Typography>
                                )}
                            </Paper>
                        </Grid>

                        {/* Fee Details Section */}
                        <Grid item xs={12} sm={12} md={8}>

                            <Paper elevation={4} style={{ padding: "20px", borderRadius: "12px", background: "#f9f9f9" }}>
                                <Typography
                                    variant="h6"
                                    style={{
                                        fontWeight: "bold",
                                        textAlign: "center",
                                        color: "#333",
                                        borderBottom: "2px solid #3f51b5",
                                        paddingBottom: "8px",
                                        marginBottom: "15px",
                                    }}
                                >
                                    💰 Fee Details
                                </Typography>

                                {filteredFees.length > 0 ? (
                                    <Grid container spacing={2}>
                                        {filteredFees.map((fee) => {
                                            return (
                                                <Grid item xs={12} sm={6} md={3} key={fee.id}>
                                                    <Paper
                                                        elevation={2}
                                                        style={{
                                                            padding: "15px",
                                                            borderRadius: "10px",
                                                            textAlign: "center",
                                                            background: "#ffffff",
                                                            border: "1px solid rgb(196, 196, 196)",
                                                            boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
                                                            minHeight: "120px", // Set a minimum height for all cards
                                                            display: "flex",
                                                            flexDirection: "column", // Allow the content to be arranged vertically
                                                            justifyContent: "space-between", // Ensure content spacing for consistent height
                                                        }}
                                                    >
                                                        <Typography variant="body1" style={{ fontWeight: "bold", color: "#333" }}>
                                                            {fee.fee_type}
                                                        </Typography>
                                                        <Typography variant="h6" style={{ color: "#3f51b5", margin: "5px 0" }}>
                                                            ₹ {fee.amount}
                                                        </Typography>

                                                        {/* Apply Discount Button */}
                                                        {["Food", "Transport"].includes(fee.fee_type) ? (
                                                            <Alert severity="info" sx={{ mb: 0 }}>
                                                                Discount not allowed.
                                                            </Alert>
                                                        ) : (
                                                            <Button
                                                                variant="outlined"
                                                                size="small"
                                                                startIcon={<DiscountIcon />}
                                                                onClick={() => handleOpenModal(fee, student)}
                                                                sx={{
                                                                    mt: 1,
                                                                    borderRadius: "8px",
                                                                    fontWeight: "bold",
                                                                    color: "#1976d2",
                                                                    borderColor: "#1976d2",
                                                                    textTransform: "none",
                                                                    "&:hover": {
                                                                        backgroundColor: "#e3f2fd",
                                                                        borderColor: "#1565c0",
                                                                    },
                                                                }}
                                                            >
                                                                Apply Discount
                                                            </Button>
                                                        )}

                                                    </Paper>
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                ) : (
                                    <Typography
                                        variant="body1"
                                        style={{ textAlign: "center", color: "#777", fontStyle: "italic", paddingTop: "10px" }}
                                    >
                                        No Fees Available
                                    </Typography>
                                )}
                            </Paper>

                            {/* Payment Modal */}
                            <Modal
                                open={openModal}
                                onClose={handleCloseModal}
                                sx={{
                                    backdropFilter: "blur(3px)",
                                    backgroundColor: "rgba(0, 0, 0, 0.3)"
                                }}
                            >
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: 440,
                                        bgcolor: "#fff",
                                        boxShadow: 8,
                                        p: 4,
                                        borderRadius: 3,
                                        border: "1px solid #ddd",
                                    }}
                                >
                                    <IconButton
                                        onClick={handleCloseModal}
                                        style={{
                                            position: "absolute",
                                            top: "10px",
                                            right: "10px",
                                            color: "#555",
                                        }}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                    {/* Modal Icon */}
                                    <Box sx={{ textAlign: "center", mb: 1 }}>
                                        <Avatar
                                            sx={{
                                                bgcolor: "#1976d2",
                                                width: 56,
                                                height: 56,
                                                margin: "0 auto",
                                                mb: 1
                                            }}
                                        >
                                            💸
                                        </Avatar>
                                    </Box>

                                    {/* Modal Heading */}
                                    <Typography
                                        variant="h6"
                                        align="center"
                                        sx={{ fontWeight: "bold", mb: 2, color: "#1976d2" }}
                                    >
                                        🧾 Apply Discount
                                    </Typography>

                                    {/* Stylish Divider */}
                                    <Box
                                        sx={{
                                            height: "2px",
                                            background: "linear-gradient(to right, #1976d2, #66bb6a)",
                                            borderRadius: 1,
                                            mb: 2
                                        }}
                                    />

                                    {/* Fee Information */}
                                    {selectedFee && (
                                        <>
                                            {/* Fee Type */}
                                            <Typography variant="body1" sx={{ fontWeight: 600 }}>
                                                {selectedFee.fee_type}
                                            </Typography>

                                            <Typography
                                                variant="h6"
                                                sx={{ color: "#2e7d32", fontWeight: "bold" }}
                                            >
                                                ₹ {selectedFee.amount}
                                            </Typography>

                                            {/* Discount Input Field */}
                                            {!["Food", "Transport"].includes(selectedFee.fee_type) ? (
                                                <TextField
                                                    label="Enter Discount Amount"
                                                    type="text" // very important!
                                                    fullWidth
                                                    value={discountAmount}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        // Allow only digits and one optional decimal point
                                                        if (/^\d*\.?\d*$/.test(value)) {
                                                            setDiscountAmount(value);
                                                        }
                                                    }}
                                                    margin="normal"
                                                    inputProps={{ inputMode: 'decimal' }}
                                                    sx={{ mb: 2 }}
                                                />

                                            ) : (
                                                <Alert severity="info" sx={{ mb: 2 }}>
                                                    Discounts are not allowed on Food or Transport fees.
                                                </Alert>
                                            )}

                                            {/* Submit Button */}
                                            <Tooltip title="Apply the discount now" arrow>
                                                <Button
                                                    variant="contained"
                                                    color="success"
                                                    fullWidth
                                                    onClick={handleSubmit}
                                                    disabled={
                                                        !discountAmount || ["Food", "Transport"].includes(selectedFee.fee_type)
                                                    }
                                                    sx={{
                                                        mt: 1,
                                                        fontWeight: "bold",
                                                        py: 1.2,
                                                        textTransform: "none",
                                                        fontSize: "16px",
                                                        borderRadius: 2,
                                                    }}
                                                >
                                                    💸 Apply Discount
                                                </Button>
                                            </Tooltip>
                                        </>
                                    )}
                                </Box>
                            </Modal>

                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
    );
};

export default StudentBill;

const renderDetail = (label, value) => (
    <div style={{
        display: "flex",
        justifyContent: "space-between",
        background: "#fff",
        padding: "8px 12px",
        borderRadius: "8px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
        fontSize: "14px"
    }}>
        <Typography variant="body2" style={{ fontWeight: "bold", color: "#444" }}>
            {label}:
        </Typography>
        <Typography variant="body2" style={{ color: "#222", fontWeight: "600" }}>
            {value}
        </Typography>
    </div>
);


